import { createAsyncThunk } from "@reduxjs/toolkit";

import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { aboutStatsApi } from "service/aboutStatsApi";

export const getAllAboutStats = createAsyncThunk(
  "getAllAboutStats",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await aboutStatsApi.getAllAboutStats();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAboutStatsById = createAsyncThunk(
  "getAboutStatsById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await aboutStatsApi.getAboutStatsById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createAboutStats = createAsyncThunk(
  "createAboutStats",
  async ({ data }, { rejectWithValue, dispatch }) => {
    try {
      const { data: response } = await aboutStatsApi.createAboutStats(data);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      dispatch(getAllAboutStats());
      return response;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const updateAboutStats = createAsyncThunk(
  "updateAboutStats",
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const { data: response } = await aboutStatsApi.updateAboutStats(id, data);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getAllAboutStats());
      return response;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);

export const deleteAboutStats = createAsyncThunk(
  "deleteAboutStats",
  async ({ id }, { rejectWithValue, dispatch }) => {
    try {
      await aboutStatsApi.deleteAboutStats(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      dispatch(getAllAboutStats());
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
